import { makeStyles, Box } from "@material-ui/core";
import ImageOutlinedIcon from '@material-ui/icons/ImageOutlined';
import Constants from "../../utils/Constants";

const IMAGE_SIZE_CSS = `${Constants.Misc.ImageSizePx}px`;

const useStyles = makeStyles({
  
  imagePlaceholder: {
    width: IMAGE_SIZE_CSS,
    height: IMAGE_SIZE_CSS,
    border: '1px solid lightgrey',
    alignContent: 'center',
    margin: '1em auto'
  }
  
});

/**
 * 
 * @param {base64Image: string, alt: string} props 
 * @returns 
 */
const InventoryImage = (props) => {
  const cssClasses = useStyles();

  const isImageSupplied = props.base64Image !== null && props.base64Image !== undefined; 

  /**
   * 
   * @returns 
   */
  const noImageToShow = () => {
    return (
      <>
        <ImageOutlinedIcon />
        <h4>Image Unavaliable</h4>
      </>
    );
  }

  /**
   * 
   * @returns 
   */
  const showImage = () => {
    let imageDataTag = Constants.Misc.ImageDataTag;
    let base64DataTagRegex = /data\:image\/[a-zA-Z]{3,4}\;base64,/;
    let image = props.base64Image;

    // Check to see if the URL image data tag is present, if
    // so make sure we dont append the default image data tag 
    if (image.match(base64DataTagRegex)?.length > 0) {
      imageDataTag = "";
    }

    return (
      <img 
        src={imageDataTag + image} 
        alt={props.alt ? props.alt : ""} 
        style={{ maxHeight: IMAGE_SIZE_CSS, maxWidth: IMAGE_SIZE_CSS }} 
      />
    )
  }

  /**
   * Render
   */
  return (
    <Box className={cssClasses.imagePlaceholder}>
      { isImageSupplied ? showImage() : noImageToShow() }
    </Box>
  );
}

export default InventoryImage;